import axios from 'axios'
//-----------------------------------果园列表
export function getReasonableList (data) {
  return axios.get(`/manage/reasonableRangePeelRate/list`, { params: data })
}
export function selectByName (data) {
  return axios.get(`/manage/universalFairValue/selectByName`, { params: data })
}
export function editFairValue (data) {
  return axios.post(`/manage/universalFairValue/edit`, data)
}
export function reasonableSave (data) {
  return axios.post(`/manage/reasonableRangePeelRate/save`, data)
}
export function reasonableDelete (ids) {
  return axios.delete(`/manage/reasonableRangePeelRate/delete`, { params: { id: ids } })
}
export function reasonableQueryById (id) {
  return axios.get(`/manage/reasonableRangePeelRate/queryById`, { params: { id: id } })
}
export function reasonablEdit (data) {
  return axios.post(`/manage/reasonableRangePeelRate/edit`, data)
} 